import { StylesConfig } from "react-select";
import { IngredientOption } from "./productRecipeEditor";
export const control =
  "block min-h-[44px] w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 disabled:bg-slate-50 disabled:text-slate-600 sm:min-h-[36px]";
export const secondary =
  "inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-100 hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 disabled:opacity-50 sm:min-h-[36px]";
export const primary =
  "inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-indigo-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 sm:min-h-[36px]";
export const ingredientSelectStyles: StylesConfig<IngredientOption, false> = {
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    borderRadius: 8,
    borderColor: state.isFocused ? "#6366f1" : "#cbd5e1",
    boxShadow: state.isFocused ? "0 0 0 2px #e0e7ff" : "none",
    backgroundColor: state.isDisabled ? "#f8fafc" : "white",
    "&:hover": { borderColor: state.isFocused ? "#6366f1" : "#94a3b8" },
  }),
  valueContainer: (base) => ({ ...base, padding: "4px 10px" }),
  singleValue: (base) => ({ ...base, maxWidth: "100%", color: "#0f172a" }),
  placeholder: (base) => ({ ...base, color: "#64748b", fontSize: 14 }),
  input: (base) => ({ ...base, margin: 0, fontSize: 14 }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({ ...base, padding: 6, color: "#94a3b8" }),
  menuPortal: (base) => ({ ...base, zIndex: 60 }),
};
